<template>
    <div class="container-fluid">
        <div class="row">

            <div class="col-md-12 col-sm-12 ">
                <div class="x_panel">
                    <div class="x_title">
                        <h2>Profile
                            <small>Creation</small>
                        </h2>
                        <div class="clearfix">
                        </div>
                    </div>
                    <div class="x_content">
                        <p>Registration of Individual/Company for Drone</p>
                        <div id="wizard" class="form_wizard wizard_horizontal">
                            <ul class="wizard_steps anchor">
                                <li v-for="step in steps" :key="step.id">
                                    <a
                                            :class="{
                                        done:step.id <= needle,
                                        selected:step.selected,
                                        disabled:!step.selected
                                    }"
                                            :style="{cursor: step.selected?'pointer':'not-allowed'}"
                                            @click="step.selected? needle = step.id:''"
                                    >
                                        <span class="step_no">{{ step.name }}</span>
                                        <span class="step_descr">
                                              Step {{ step.id }}<br>
                                              <small>{{ step.description }}</small>
                                        </span>
                                    </a>
                                </li>
                            </ul>

                            <div class="stepContainer" style="height: 470px">
                                <div id="step-1" class="content" :style="{display: (needle===1) && 'block' || 'none'}">
                                    <div class="form-horizontal form-label-left">
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align">
                                                Registration For</label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <div id="type" class="btn-group">
                                                    <label
                                                            :class="registration.type==='individual'?'btn btn-primary':'btn btn-secondary'">
                                                        <input type="radio" v-model="registration.type"
                                                               value="individual"> Individual
                                                    </label>
                                                    <label
                                                            :class="registration.type==='company'?'btn btn-primary':'btn btn-secondary'">
                                                        <input type="radio" v-model="registration.type" value="company">Company
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="full_name">
                                                {{ registration.type === 'individual' ? 'Owner' : 'Company' }} Name<span
                                                    class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input type="text" id="full_name"
                                                       v-model="registration.full_name"
                                                       required="required"
                                                       :class="{'form-control':true,'is-invalid':response_error.full_name && response_error.full_name.length}"
                                                       @input="validate({full_name:$event.target.value})"
                                                >

                                                <template
                                                        v-if="response_error.full_name && response_error.full_name.length">
                                                    <div class="text-danger"
                                                         v-for="(error,key) in response_error.full_name" :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="citizenship_no">
                                                {{
                                                registration.type === 'individual' ? 'Citizenship/Passport' :
                                                'Registration'
                                                }} No<span
                                                    class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6">
                                                <input type="text" id="citizenship_no"
                                                       v-model="registration.citizenship_no"
                                                       required="required"
                                                       :class="{'form-control':true,'is-invalid':response_error.citizenship_no && response_error.citizenship_no.length}"
                                                       @input="validate({citizenship_no:$event.target.value})"
                                                >

                                                <template
                                                        v-if="response_error.citizenship_no && response_error.citizenship_no.length">
                                                    <div class="text-danger"
                                                         v-for="(error,key) in response_error.citizenship_no"
                                                         :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="dob">{{
                                                registration.type === 'individual' ? 'Birth' : 'Established'
                                                }}
                                                Date
                                                <span class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input
                                                        id="dob"
                                                        v-model="registration.dob"
                                                        :class="{'date-picker':true, 'form-control':true,'is-invalid':response_error.dob && response_error.dob.length}"
                                                        required="required"
                                                        type="date"
                                                        @input="validate({dob:$event.target.value,type:registration.type})"
                                                >

                                                <template v-if="response_error.dob && response_error.dob.length">
                                                    <div class="text-danger" v-for="(error,key) in response_error.dob"
                                                         :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="phone">Phone <span class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input type="text" id="phone"
                                                       v-model="registration.phone"
                                                       required="required"
                                                       :class="{'form-control':true,'is-invalid':response_error.phone && response_error.phone.length}"
                                                       @input="validate({phone:$event.target.value})"
                                                >

                                                <template v-if="response_error.phone && response_error.phone.length">
                                                    <div class="text-danger" v-for="(error,key) in response_error.phone"
                                                         :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="username">Username <span class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input type="text" id="username" v-model="registration.username"
                                                       required="required"
                                                       :class="{'form-control':true,'is-invalid':response_error.username && response_error.username.length}"

                                                       @input="validate({username:$event.target.value})"
                                                >

                                                <template
                                                        v-if="response_error.username && response_error.username.length">
                                                    <div class="text-danger"
                                                         v-for="(error,key) in response_error.username" :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="email">Email <span class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input type="email" id="email" v-model="registration.email"
                                                       required="required"
                                                       :class="{'form-control':true,'is-invalid':response_error.email && response_error.email.length}"
                                                       @input="validate({email:$event.target.value})">

                                                <template v-if="response_error.email && response_error.email.length">
                                                    <div class="text-danger" v-for="(error,key) in response_error.email"
                                                         :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="password">Password <span
                                                    class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input type="password" id="password" v-model="registration.password"
                                                       required="required"
                                                       :class="{'form-control':true,'is-invalid':response_error.password && response_error.password.length}"

                                                       @input="response_error.password=null">

                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="password_confirmation">Confirm Password <span
                                                    class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input
                                                        type="password"
                                                        id="password_confirmation"
                                                        v-model="registration.password_confirmation" required="required"
                                                        :class="{'form-control':true,'is-invalid':response_error.password && response_error.password.length}"
                                                        @input="response_error.password=null"
                                                >
                                                <template
                                                        v-if="response_error.password && response_error.password.length">
                                                    <div class="text-danger"
                                                         v-for="(error,key) in response_error.password" :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="text-danger"
                                                         v-if="registration.password!==registration.password_confirmation">
                                                        Password Confirmation did not match
                                                    </div>
                                                    <div class="text-danger"
                                                         v-if="registration.password && registration.password.length <6 || registration.password_confirmation && registration.password_confirmation<6">
                                                        Password length must be min 6 character
                                                    </div>
                                                </template>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div id="step-2" class="content" :style="{display: (needle===2) && 'block' || 'none'}">
                                    <div class="form-horizontal form-label-left">
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="national_id">Country <span class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <v-select
                                                        label="value"
                                                        :options="nations"
                                                        :reduce="country => country.id"
                                                        id="national_id"
                                                        v-model="registration.nationality_id" required="required"
                                                        @input="validate({nationality_id:registration.nationality_id})"
                                                ></v-select>

                                                <template
                                                        v-if="response_error.nationality_id && response_error.nationality_id.length">
                                                    <div class="text-danger"
                                                         v-for="(error,key) in response_error.nationality_id"
                                                         :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="state">State <span
                                                    class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input type="text" id="state"
                                                       v-model="registration.state" required="required"
                                                       :class="{'form-control':true,'is-invalid':response_error.state && response_error.state.length}"
                                                       @input="validate({state:registration.state})"
                                                >

                                                <template v-if="response_error.state && response_error.state.length">
                                                    <div class="text-danger"
                                                         v-for="(error,key) in response_error.state"
                                                         :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="district">District <span class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input type="text" id="district" v-model="registration.district"
                                                       required="required"
                                                       :class="{'form-control':true,'is-invalid':response_error.district && response_error.district.length}"
                                                       @input="validate({district:registration.district})"
                                                >

                                                <template
                                                        v-if="response_error.district && response_error.district.length">
                                                    <div class="text-danger"
                                                         v-for="(error,key) in response_error.district"
                                                         :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="municipality">Municipality <span class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input type="text" id="municipality" v-model="registration.municipality"
                                                       required="required"
                                                       :class="{'form-control':true,'is-invalid':response_error.municipality && response_error.municipality.length}"
                                                       @input="validate({municipality:registration.municipality})"
                                                >
                                                <template
                                                        v-if="response_error.municipality && response_error.municipality.length">
                                                    <div class="text-danger"
                                                         v-for="(error,key) in response_error.municipality" :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label col-md-3 col-sm-3 label-align"
                                                   for="ward">Ward No. <span class="required">*</span>
                                            </label>
                                            <div class="col-md-6 col-sm-6 ">
                                                <input type="number" min="1" id="ward" v-model="registration.ward"
                                                       required="required"
                                                       :class="{'form-control':true,'is-invalid':response_error.ward && response_error.ward.length}"
                                                       @input="validate({ward:registration.ward})"
                                                >
                                                <template v-if="response_error.ward && response_error.ward.length">
                                                    <div class="text-danger"
                                                         v-for="(error,key) in response_error.ward" :key="key">
                                                        {{ error }}
                                                    </div>
                                                </template>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div id="step-3" class="content" :style="{display: (needle===3) && 'block' || 'none'}">
                                    <div class="form-horizontal form-label-left">

                                        <div class="form-group row" style="height: 200px">
                                            <div class="col-md-6 card border-0 p-2 text-center">

                                                <label class="label-align text-center"
                                                       for="avatar">
                                                    <div v-if="url">
                                                        <img :src="url" alt="" height="150px">
                                                        <button @click="clearAvatar"><i
                                                                class="fa fa-times"></i></button>
                                                    </div>
                                                    <div v-else>
                                                        <i class="fa fa-user large_icon"></i>
                                                    </div>
                                                    Upload {{registration.type==='individual'?'Photo':'Logo'}}
                                                    <span
                                                            class="required">*</span>
                                                </label>
                                                <div class="d-none">
                                                    <input
                                                            type="file"
                                                            id="avatar"
                                                            ref="avatar"
                                                            required="required"
                                                            accept="image/*"
                                                            max="300"
                                                            :class="{'form-control':true,'is-invalid':response_error.avatar && response_error.avatar.length}"
                                                            @change="handleAvatarUpload"
                                                    >
                                                </div>

                                                <template
                                                        v-if="response_error.avatar && response_error.avatar.length">

                                                    <div v-if="registration.type=='individual'">
                                                        <div class="text-danger"
                                                             v-for="(error,key) in response_error.avatar" :key="key">
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                    <div v-else class="text-danger">
                                                        Logo is missing or more than 300kb
                                                    </div>
                                                </template>
                                            </div>

                                            <div class="col-md-6 card border-0 p-2 text-center">


                                                <label class="label-align text-center"
                                                       for="citizenship">
                                                    <div v-if="cit_url">
                                                        <img :src="cit_url" alt="" height="150px">
                                                        <button @click="clearCitizenship"><i
                                                                class="fa fa-times"></i></button>
                                                    </div>
                                                    <div v-else>
                                                        <i class="fa fa-id-card large_icon"></i>
                                                    </div>
                                                    Upload
                                                    {{registration.type==='individual'?
                                                    'Citizenship(Both Sides)/Passport':'Registration Certificate'}}
                                                    <span
                                                            class="required">*</span>
                                                </label>
                                                <div class="d-none">
                                                    <input
                                                            type="file"
                                                            id="citizenship"
                                                            ref="citizenship"
                                                            required="required"
                                                            accept="image/*"
                                                            max="300"
                                                            :class="{'form-control':true,'is-invalid':response_error.citizenship && response_error.citizenship.length}"
                                                            @change="handleCitizenshipUpload"
                                                    >
                                                </div>

                                                <template
                                                        v-if="response_error.citizenship && response_error.citizenship.length">

                                                    <div v-if="registration.type=='individual'">
                                                        <div class="text-danger"
                                                             v-for="(error,key) in response_error.citizenship"
                                                             :key="key">
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                    <div v-else class="text-danger">
                                                        Registration certificate is missing or more than 300kb
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <!-- End SmartWizard Content -->
                        <div class="actionBar">
                            <button class="buttonPrevious btn btn-primary" :class="{buttonDisabled:needle===1}"
                                    @click.prevent="previous">Previous
                            </button>
                            <button class="buttonNext btn btn-success" :disabled="!valid_1" @click.prevent="next">
                                {{ needle === steps.length ? 'Submit' : 'Next' }}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import vSelect from "vue-select"
    import Vue from "vue";

    export default {
        components: {
            vSelect
        },
        data() {
            return {
                form_data: new FormData(),
                url: "",
                cit_url: '',
                response_error: {
                    full_name: [],
                    citizenship_no: [],
                    dob: [],
                    email: [],
                    phone: [],
                    username: [],
                    password: [],
                    nationality_id: [],
                    state: [],
                    district: [],
                    municipality: [],
                    ward: [],
                    avatar: [],
                    citizenship: []
                },
                needle: 1,
                steps: [
                    {
                        id: 1,
                        name: 'A',
                        description: 'Basic Information',
                        selected: true
                    },
                    {
                        id: 2,
                        name: 'B',
                        description: 'Contact - Address ',
                        selected: false
                    },
                    {
                        id: 3,
                        name: 'C',
                        description: 'Document Upload ',
                        selected: false
                    }
                ],
                registration: {
                    id: null,
                    type: 'individual',
                    full_name: null,
                    citizenship_no: null,
                    dob: null,
                    email: null,
                    phone: null,
                    username: null,
                    password: null,
                    password_confirmation: null,
                    nationality_id: null,
                    state: null,
                    district: null,
                    municipality: null,
                    ward: 1,
                    avatar: null,
                    citizenship: null,
                },
                nations: []
            }
        },
        mounted() {
            this.loadNations()
        },
        computed: {
            valid_1() {
                return !(
                    (this.response_error.full_name && this.response_error.full_name.length) ||
                    (this.response_error.citizenship_no && this.response_error.citizenship_no.length) ||
                    (this.response_error.dob && this.response_error.dob.length) ||
                    (this.response_error.email && this.response_error.email.length) ||
                    (this.response_error.phone && this.response_error.phone.length) ||
                    (this.response_error.username && this.response_error.username.length) ||
                    (this.response_error.password && this.response_error.password.length)
                );

            },
            valid_2() {
                return this.valid_1 && !(
                    (this.response_error.nationality_id && this.response_error.nationality_id.length) ||
                    (this.response_error.state && this.response_error.state.length) ||
                    (this.response_error.district && this.response_error.district.length) ||
                    (this.response_error.municipality && this.response_error.municipality.length) ||
                    (this.response_error.ward && this.response_error.ward.length)
                )
            },
            valid_3() {
                return this.valid_2
            },
        },
        watch: {
            needle: function (newValue) {
                this.steps[newValue - 1].selected = true
            },
            response_error: (newValue) => {
                console.log(newValue)
            },
            "registration.full_name": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.registration.full_name = this.titleCase(newValue)
                    this.form_data.append("full_name", this.registration.full_name)
                }

            },
            "registration.state": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.registration.state = this.titleCase(newValue)
                    this.form_data.append("state", this.registration.state)
                }

            },
            "registration.district": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.registration.district = this.titleCase(newValue)
                    this.form_data.append("district", this.registration.district)
                }

            },
            "registration.municipality": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.registration.municipality = this.titleCase(newValue)
                    this.form_data.append("municipality", this.registration.municipality)
                }

            },
            "registration.ward": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.form_data.append("ward", this.registration.ward)
                }

            },
            "registration.type": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.form_data.append("type", this.registration.type)
                }

            },
            "registration.citizenship_no": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.form_data.append("citizenship_no", this.registration.citizenship_no)
                }

            },
            "registration.dob": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.form_data.append("dob", this.registration.dob)
                }

            },
            "registration.email": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.form_data.append("email", this.registration.email)
                }

            },
            "registration.phone": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.form_data.append("phone", this.registration.phone)
                }

            },
            "registration.username": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.form_data.append("username", this.registration.username)
                }

            },
            "registration.password": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.form_data.append("password", this.registration.password)
                }

            },
            "registration.password_confirmation": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.form_data.append("password_confirmation", this.registration.password_confirmation)
                }

            },
            "registration.nationality_id": function (newValue) {
                if (newValue) {
                    newValue = newValue.toString()
                    this.form_data.append("nationality_id", this.registration.nationality_id)
                }

            },
        },
        methods: {
            titleCase(str) {
                str = str.replace(/\s\s+/g, ' ')
                const sentence = str.split(" ")
                str = ''
                for (let i = 0; i < sentence.length; i++) {
                    str += (i !== 0 ? " " : "") + (sentence[i][0] ? sentence[i][0].toUpperCase() : "") + sentence[i].slice(1);
                }
                return str
            },
            validate(property) {
                NProgress.start();
                const propertyName = Object.keys(property)[0]
                axios.post('/api/v1/registration-validate-only', property)
                    .then(response => {
                        this.response_error[propertyName] = []
                    })
                    .catch(error => {
                        this.response_error[propertyName] = error.response.data.errors[propertyName]
                    })
                NProgress.done();
            },
            next() {
                NProgress.start();
                if (this['valid_' + this.needle]) {
                    if (this.needle === this.steps.length) {
                        this.form_data.append("type", this.registration.type)
                        this.form_data.append("nationality_id", this.registration.nationality_id)
                        this.form_data.append("ward", this.registration.ward)
                        axios.post('/api/v1/new-register', this.form_data)
                            .then(response => {
                                Vue.$vToastify.success('Registration success. Redirecting to dashboard')
                                location.href = "/";
                            }).catch(error => {
                            console.log(error)
                            this.response_error = error.response.data.errors
                            Vue.$vToastify.error('Invalid Data. Please correct the form')
                        })
                    } else
                        this.needle++
                } else
                    Vue.$vToastify.error('! Invalid form Data.')

                NProgress.done();
            },
            previous() {
                this.needle--
            },
            loadNations() {
                NProgress.start();
                axios.get('/api/v1/nationality/properties')
                    .then(response => {
                        this.nations = response.data.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
                NProgress.done();
            },
            handleAvatarUpload() {
                this.registration.avatar = this.$refs.avatar.files[0];
                this.url = URL.createObjectURL(this.$refs.avatar.files[0]);
                this.form_data.append("avatar", this.registration.avatar)
                this.response_error.avatar = []
            },
            handleCitizenshipUpload() {
                this.registration.citizenship = this.$refs.citizenship.files[0];
                this.cit_url = URL.createObjectURL(this.$refs.citizenship.files[0]);
                this.form_data.append("citizenship", this.registration.citizenship)
                this.response_error.citizenship = []
            },
            clearAvatar() {
                this.form_data.append("avatar", null)
                this.url = ''
            },
            clearCitizenship() {
                this.form_data.append("citizenship", null)
                this.cit_url = ''
            }
        }
    }
</script>
<style scoped>
    .large_icon {
        font-size: 12em;
    }
</style>
